import clsx from "clsx";
import React from "react";
import styled from "styled-components";
import styledProps from "styled-props";
import { darken } from "polished";
import "./style.scss";

const StyledButton = styled.button`
  background-color: ${(props) => props.color};
  &:after,
  &:before {
    background-color: ${(props) => props.color};
  }

  &:hover,
  &:hover:after,
  &:hover:before {
    background-color: ${(props) =>
      darken(0.08, props.color || (props.secondary ? "#d8232a" : "#0a164c"))};
  }
`;

export default function Button({
  children,
  left,
  right,
  dropdown,
  secondary,
  onClick,
  style,
  className,
  mt,
  color,
  ...rest
}) {
  const classes = clsx(
    className,
    "btn btn-blue rounded-pill mb-2 me-1",
    { "button--i-left": left },
    { "button--i-right": right },
    { "js-button__dropdown": dropdown },
    { "button--secondary": secondary },
    { "button--mt": mt }
  );

  return (
    <StyledButton
      type="button"
      className={classes}
      color={color}
      onClick={onClick ? () => onClick() : () => {}}
      style={{ border: "none", ...style }}
      secondary={secondary}
      {...rest}
    >
      {children}
    </StyledButton>

  );
}
